<template>
  <div 
    class="fill-height">
    <v-layout wrap>
      <v-flex>
        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              class="body-1 font-weight-bold text-capitalize"
              color="white"
              icon
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <v-dialog v-model="dialog.form"
          @keydown.esc="dialog.form = false; dialog.form = true;"
          :fullscreen="dialog.fullscreen"
          width="1000"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
            class="pa-2">
            <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header text-capitalize">
              {{ files[selected.file].text }}

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.form = false; dialog.fullscreen = false; dialog.form = form.id === '' ? true : false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider class="mx-4 mt-3 mb-2"/>

            <v-card-text
              class="mt-4">
              <ValidationObserver 
                ref="form">
                <div v-if="selected.file == 0">
                  <div
                    class="body-2 font-italic mb-2">
                    Silahkan upload data dokumen dengan format PDF:
                  </div>

                  <uploaddocument 
                    v-model="upload.doc">
                    <div slot="activator">
                      <v-btn
                        :disabled="process.doc"
                        :loading="process.doc"
                        block
                        height="40"
                        :color="`${set_color_rgb_down}`"
                        elevation="0"
                        class="body-2 font-weight-bold text-capitalize d-flex align-center mb-4"
                        :style="`color: ${set_color};`"
                        style="border-radius: 10px;">
                        <v-icon>mdi-file-pdf-box</v-icon>

                        <span
                          class="ml-2">
                          Upload Data PDF
                        </span>
                      </v-btn>
                    </div>
                  </uploaddocument>

                  <v-card v-if="form.url !== ''"
                    flat
                    style="border: 2px solid #f0f0f0; border-radius: 10px; position: sticky; top: 12px;">
                    <div
                      ref="arsippdf">
                      <iframe
                        :src="`${form.url}#toolbar=0`" 
                        allowfullscreen
                        frameborder="0" 
                        width="100%"
                        height="750"
                        style="border-radius: 10px; border: 2px solid #323639;">
                      </iframe>
                    </div>
                  </v-card>
                </div>

                <div v-if="selected.file == 1">
                  <div
                    class="body-2 font-italic mb-2">
                    Silahkan upload data dokumen dengan format Gambar:
                  </div>

                  <uploadimage
                    v-model="upload.image">
                    <div slot="activator">
                      <v-btn
                        :disabled="process.image"
                        :loading="process.image"
                        block
                        height="40"
                        :color="`${set_color_rgb_down}`"
                        elevation="0"
                        class="body-2 font-weight-bold text-capitalize d-flex align-center mb-4"
                        :style="`color: ${set_color};`"
                        style="border-radius: 10px;">
                        <v-icon>mdi-image-outline</v-icon>

                        <span
                          class="ml-2">
                          Upload Data Gambar
                        </span>
                      </v-btn>
                    </div>
                  </uploadimage>

                  <v-card v-if="form.url !== ''"
                    flat
                    style="border: 2px solid #f0f0f0; border-radius: 10px; position: sticky; top: 12px;">
                    <v-img 
                      contain
                      :src="form.url"
                      class="ma-auto"
                      style="border-radius: 10px;">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-card>
                </div>
              </ValidationObserver>

              <div v-if="message.error.length > 0"
                class="text-center my-4">
                <div
                  class="error--text d-flex align-start">
                  <v-icon size="18" color="red" class="mt-1">mdi-alert-circle-outline</v-icon>
                  
                  <span
                    class="ml-1">
                    {{ message.error }}
                  </span>
                </div>
              </div>
            </v-card-text>

            <v-divider class="mx-4 mb-3 mt-0"/>

            <v-card-actions>
              <v-spacer/>

              <v-btn
                color="green"
                elevation="0"
                rounded
                width="120"
                class="body-2 font-weight-bold text-capitalize white--text"
                :loading="process.form"
                :disabled="process.form || form.url === ''"
                v-on:keyup.enter="save()"
                @click="save()">
                <v-icon small class="mr-1">mdi-check-bold</v-icon>
                Simpan
              </v-btn>

              <v-btn
                outlined
                rounded
                width="120"
                class="body-2 font-weight-bold text-capitalize red--text"
                :disabled="process.form"
                @click="dialog.form = false; dialog.fullscreen = false; dialog.form = form.id === '' ? true : false;">
                <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
                Batal
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="dialog.preview"
          @keydown.esc="dialog.preview = false; dialog.preview = true;"
          :fullscreen="dialog.fullscreen"
          width="1000"
          persistent
          scrollable>
          <v-card 
            :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius'"
            class="pa-2">
            <v-card-title class="d-flex align-center py-0 px-3 text-right popup-header text-capitalize">
              Preview Dokumen {{ files[selected.file].text }}

              <v-spacer/>

              <v-icon 
                @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
                class="cursor-pointer mr-1"
                size="24"
                :color="set_color">
                {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
              </v-icon>

              <v-icon 
                @click="dialog.preview = false; dialog.fullscreen = false; dialog.preview = form.id === '' ? true : false;"
                class="cursor-pointer"
                size="24"
                color="red">
                mdi-close-circle-outline
              </v-icon>
            </v-card-title>
            
            <v-divider class="mx-4 mt-3 mb-2"/>

            <v-card-text
              class="mt-4">
              <div v-if="selected.file == 0">
                <v-card v-if="preview_index !== ''"
                  flat
                  style="border: 2px solid #f0f0f0; border-radius: 10px; position: sticky; top: 12px;">
                  <div
                    ref="arsippdf">
                    <iframe
                      :src="`${detail.file_doc_json_array[preview_index].url}#toolbar=0`" 
                      allowfullscreen
                      frameborder="0" 
                      width="100%"
                      height="750"
                      style="border-radius: 10px; border: 2px solid #323639;">
                    </iframe>
                  </div>
                </v-card>
              </div>

              <div v-if="selected.file == 1">
                <v-card v-if="preview_index !== ''"
                  flat
                  style="border: 2px solid #f0f0f0; border-radius: 10px; position: sticky; top: 12px;">
                  <v-img 
                    contain
                    :src="detail.image_doc_json_array[preview_index].url"
                    class="ma-auto"
                    style="border-radius: 10px;">
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height"
                        align="center"
                        justify="center">
                        <v-progress-circular 
                          indeterminate 
                          :color="set_color">
                        </v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-card>
              </div>
            </v-card-text>

            <v-divider class="mx-4 mb-3 mt-0"/>

            <v-card-actions>
              <v-spacer/>

              <v-btn
                outlined
                rounded
                width="120"
                class="body-2 font-weight-bold text-capitalize red--text"
                @click="dialog.preview = false; dialog.fullscreen = false; preview_index = '';">
                <v-icon color="red" small class="mr-1">mdi-close-circle</v-icon>
                Tutup
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        
        <section>
          <v-row
            class="pa-4 pb-2 pr-1">
            <v-col
              cols="12">
              <v-card
                @click="$router.go(-1)"
                flat
                color="transparent"
                style="width: 20%;">
                <div
                  class="d-flex align-center">
                  <v-avatar
                    tile
                    size="28"
                    style="opacity: 30%;">
                    <v-img
                      contain
                      alt="amanata"  
                      :src="require('@/assets/icon/back_arrow.png')">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            size="20"
                            indeterminate 
                            :color="set_color">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-avatar>

                  <span
                    class="title black--text ml-3"
                    style="font-weight: 600;">
                    Detail Agenda
                  </span>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row
            class="pa-4 py-0 pr-1">
            <v-col
              cols="6"
              class="pt-0">
              <v-tabs 
                v-model="selected.menu"
                flat
                grow
                slider-size="5"
                :color="set_color"
                style="border-radius: 10px !important;">
                <v-tab
                  class="d-flex justify-start"
                  v-for="(item, index) in menu"
                  :key="index"
                  style="min-width: 70px; border-radius: 10px !important; background-color: #f9f9f9;">
                  <div
                    class="d-flex align-center">
                    <v-avatar
                      tile
                      size="18">
                      <v-img
                        contain
                        alt="amanata"  
                        :src="item.icon">
                        <template v-slot:placeholder>
                          <v-row
                            class="fill-height"
                            align="center"
                            justify="center">
                            <v-progress-circular 
                              size="20"
                              indeterminate 
                              :color="set_color">
                            </v-progress-circular>
                          </v-row>
                        </template>
                      </v-img>
                    </v-avatar>

                    <span
                      class="text-capitalize ml-2"
                      :class="selected.menu === index ? 'font-weight-bold' : ''">
                      {{ item.text }}
                    </span>
                  </div>
                </v-tab>
              </v-tabs>
            </v-col>
          </v-row>

          <v-row v-if="selected.menu == 0"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="py-0">
              <v-card
                flat
                min-height="calc(100vh - 238px)"
                style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                <v-card-text>
                  <v-card
                    flat
                    class="mb-4"
                    style="border: 2px dashed #e0e0e0; border-radius: 10px;">
                    <v-img 
                      contain
                      height="320"
                      alt="amanata" 
                      :src="detail.image_url === '' ? require('@/assets/image/image_default.png') : detail.image_url"
                      class="ma-auto"
                      style="border-radius: 10px;">
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height"
                          align="center"
                          justify="center">
                          <v-progress-circular 
                            indeterminate 
                            color="white">
                          </v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                  </v-card>

                  <v-row>
                    <v-col
                      cols="12"
                      md="12">
                      <div
                        class="mb-4">
                        <div
                          class="body-1 font-weight-bold black--text">
                          {{ detail.title }}
                        </div>

                        <div
                          class="line-text-second">
                          Dibuat {{ detail.input_datetime | date }}
                        </div>
                      </div>

                      <div
                        class="mb-4">
                        <div
                          class="body-1 font-weight-bold black--text">
                          Deskripsi
                        </div>

                        <div
                          class="line-text-second">
                          {{ detail.desc }}
                        </div>
                      </div>

                      <div
                        class="mb-4">
                        <div
                          class="body-1 font-weight-bold black--text">
                          Lokasi
                        </div>

                        <div
                          class="line-text-second">
                          {{ detail.location }}
                        </div>
                      </div>

                      <div
                        class="mb-4">
                        <div
                          class="body-1 font-weight-bold black--text">
                          Tanggal
                        </div>

                        <div
                          class="line-text-second">
                          {{ detail.start_date | date }} <span class="mx-2">s/d</span> {{ detail.end_date | date }}
                        </div>
                      </div>

                      <div
                        class="mb-4">
                        <div
                          class="body-1 font-weight-bold black--text">
                          Jam
                        </div>

                        <div
                          class="line-text-second">
                          {{ `${detail.start_time.split(':')[0]}:${detail.start_time.split(':')[1]}` }} <span class="mx-2">s/d</span> {{ `${detail.end_time.split(':')[0]}:${detail.end_time.split(':')[1]}` }}
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row v-if="selected.menu == 1"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="py-0">
              <v-card
                flat
                min-height="calc(100vh - 238px)"
                style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                <v-card-text
                  class="d-flex justify-center my-8">
                  <qr-code 
                    id="download_qr"
                    :text="detail.uuid"
                    :size="rps !== 'lg' ? 325 : 500">
                  </qr-code>
                </v-card-text>

                <div
                  class="text-center">
                  <v-btn
                    @click="to_download()"
                    color="green"
                    elevation="0"
                    style="border-radius: 10px;"
                    class="body-2 font-weight-bold text-capitalize white--text">
                    Download QR Kode
                  </v-btn>
                </div>
              </v-card>
            </v-col>
          </v-row>

          <v-row v-if="selected.menu == 2"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="py-0">
              <v-card
                flat
                min-height="calc(100vh - 238px)"
                style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                <v-card-text>
                  <div
                    class="d-flex align-center mb-4">
                    <div
                      class="d-flex align-center">
                      Total Pengunjung : <strong class="black--text ml-1">{{ detail.user_event.length }}</strong>
                    </div>

                    <v-spacer />

                    <v-btn
                      @click="prints()"
                      :disabled="process.print"
                      :loading="process.print"
                      color="#444444"
                      elevation="0"
                      style="border-radius: 10px;"
                      class="body-2 font-weight-bold text-capitalize white--text">
                      <v-icon>mdi-microsoft-excel</v-icon>
                      
                      <span
                        class="ml-1">
                        Export
                      </span>
                    </v-btn>
                  </div>

                  <v-simple-table
                    class="my-2"
                    style="border: 2px dashed #e0e0e0; border-radius: 10px;">
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">
                            Foto
                          </th>
                          <th class="text-left">
                            Nomor Induk Pegawai
                          </th>
                          <th class="text-left">
                            Unit
                          </th>
                          <th class="text-left">
                            Nama Lengkap
                          </th>
                          <th class="text-left">
                            Telepon
                          </th>
                          <th class="text-left">
                            Tanggal
                          </th>
                        </tr>
                      </thead>
                      
                      <tbody>
                        <tr
                          v-for="(item, index) in detail.user_event"
                          :key="index"
                          style="opacity: 70%;">
                          <td
                            style="border: none !important;">
                            <v-avatar
                              size="30">
                              <v-img 
                                contain
                                alt="amanata" 
                                :src="item.user_image_url !== '' ? item.user_image_url : require('@/assets/image/image_default.png')"
                                class="ma-auto"
                                style="border-radius: 10px;">
                                <template v-slot:placeholder>
                                  <v-row
                                    class="fill-height"
                                    align="center"
                                    justify="center">
                                    <v-progress-circular 
                                      indeterminate 
                                      color="white">
                                    </v-progress-circular>
                                  </v-row>
                                </template>
                              </v-img>
                            </v-avatar>
                          </td>
                          <td
                            style="border: none !important;">
                            {{ item.user_code }}
                          </td>
                          <td
                            style="border: none !important;">
                            {{ item.unit_name }}
                          </td>
                          <td
                            style="border: none !important;">
                            {{ item.user_name }}
                          </td>
                          <td
                            style="border: none !important;">
                            {{ item.user_mobilephone }}
                          </td>
                          <td
                            style="border: none !important;">
                            {{ item.created_datetime | datetime }}
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>

          <v-row v-if="selected.menu == 3"
            class="pa-4 pr-1">
            <v-col 
              cols="12"
              md="12"
              class="py-0">
              <v-card
                flat
                min-height="calc(100vh - 238px)"
                style="border-radius: 10px; border: 1px solid #E7E7E7; overflow-y: auto;">
                <v-card-text>
                  <div
                    class="d-flex align-center mb-3">
                    <div>
                      Total Dokumentasi : <strong class="black--text ml-1">{{ detail.file_doc_json_array.length + detail.image_doc_json_array.length }}</strong>
                    </div>

                    <v-spacer />

                    <div
                      class="d-flex align-center">
                      <v-btn
                        v-for="(item, index) in files"
                        :key="index"

                        @click="selected.file = index"
                        elevation="0"
                        width="120"
                        :style="index < 1 ? 'border-radius: 50px 0px 0px 50px;' : 'border-radius: 0px 50px 50px 0px;'"
                        :class="index === selected.file ? 'white--text' : 'grey--text'"
                        :color="index === selected.file ? set_color : ''"
                        class="body-2 text-capitalize font-weight-bold d-flex align-center">
                        <v-icon size="18">{{ item.icon }}</v-icon>
                        
                        <span class="ml-1">
                          {{ item.text }}
                        </span>
                      </v-btn>
                    </div>
                  </div>

                  <v-card
                    flat
                    class="pa-4"
                    height="calc(100vh - 320px)"
                    style="overflow-y: auto; border-radius: 10px; border: 1px dashed #E7E7E7; ">
                    <v-btn
                      @click="dialog.form = true; reset();"
                      color="#4B4B4B"
                      elevation="0"
                      width="118"
                      class="body-2 white--text text-capitalize d-flex align-center mb-2"
                      style="border-radius: 10px; font-weight: 600; background: linear-gradient(180deg, rgba(63, 148, 62, 1), rgba(22, 115, 20, 1));">
                      <v-icon size="20">mdi-plus-circle-multiple</v-icon>
                      
                      <span
                        class="ml-2">
                        Tambah
                      </span>
                    </v-btn>

                    <v-row v-if="process.load">
                      <v-col
                        cols="12"
                        md="3"
                        v-for="(item, index) in 4"
                        :key="index">
                        <v-skeleton-loader
                          class="ma-auto"
                          :loading="process.load"
                          type="image">
                        </v-skeleton-loader>
                      </v-col>
                    </v-row>

                    <v-row v-if="!process.load && selected.file == 0">
                      <v-col
                        cols="12"
                        md="3"
                        v-for="(item, index) in detail.file_doc_json_array"
                        :key="index">
                        <v-card v-if="!process.load && detail.file_doc_json_array.length > 0"
                          flat
                          color="#f0f0f0"
                          style="border-radius: 10px;">
                          <v-list
                            flat
                            color="transparent"
                            class="py-0">
                            <v-list-item>
                              <v-list-item-avatar
                                class="ml-0 mr-2">
                                <v-icon color="red">mdi-file-pdf-box</v-icon>
                              </v-list-item-avatar>

                              <v-list-item-content>
                                <v-list-item-title 
                                  class="body-2 text-capitalize">
                                  {{ item.title }}
                                </v-list-item-title>
                              </v-list-item-content>

                              <v-list-item-action
                                class="ma-0 ml-2">
                                <v-menu
                                  transition="slide-x-transition"
                                  bottom
                                  right
                                  offset-y>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      v-bind="attrs"
                                      v-on="on"

                                      icon>
                                      <v-icon>mdi-dots-vertical</v-icon>
                                    </v-btn>
                                  </template>

                                  <v-list
                                    dense>
                                    <v-list-item
                                      v-for="(item_action, index_action) in menu_action"
                                      :key="index_action"
                                      @click="toAction(item_action.text, index, 'pdf')"
                                      class="pl-0 pr-3">
                                      <v-list-item-avatar
                                        class="ma-0">
                                        <v-icon
                                          size="20">
                                          {{ item_action.icon }}
                                        </v-icon>
                                      </v-list-item-avatar>

                                      <v-list-item-content>
                                        <v-list-item-title
                                          class="body-2 text-capitalize">
                                          {{ item_action.text }}
                                        </v-list-item-title>
                                      </v-list-item-content>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                              </v-list-item-action>
                            </v-list-item>
                          </v-list>

                          <v-card-text
                            class="pt-0">
                            <v-img
                              height="200"
                              :src="require('@/assets/image/word_default.jpeg')">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>

                    <v-row v-if="!process.load && selected.file == 1">
                      <v-col
                        cols="12"
                        md="3"
                        v-for="(item, index) in detail.image_doc_json_array"
                        :key="index">
                        <v-card v-if="!process.load && detail.image_doc_json_array.length > 0"
                          flat
                          color="#f0f0f0"
                          style="border-radius: 10px;">
                          <v-list
                            flat
                            color="transparent"
                            class="py-0">
                            <v-list-item>
                              <v-list-item-avatar
                                class="ml-0 mr-2">
                                <v-icon color="blue">mdi-image-outline</v-icon>
                              </v-list-item-avatar>

                              <v-list-item-content>
                                <v-list-item-title 
                                  class="body-2 text-capitalize">
                                  {{ item.title }}
                                </v-list-item-title>
                              </v-list-item-content>

                              <v-list-item-action
                                class="ma-0 ml-2">
                                <v-menu
                                  transition="slide-x-transition"
                                  bottom
                                  right
                                  offset-y>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      v-bind="attrs"
                                      v-on="on"

                                      icon>
                                      <v-icon>mdi-dots-vertical</v-icon>
                                    </v-btn>
                                  </template>

                                  <v-list
                                    dense>
                                    <v-list-item
                                      v-for="(item_action, index_action) in menu_action"
                                      :key="index_action"
                                      @click="toAction(item_action.text, index, 'image')"
                                      class="pl-0 pr-3">
                                      <v-list-item-avatar
                                        class="ma-0">
                                        <v-icon
                                          size="20">
                                          {{ item_action.icon }}
                                        </v-icon>
                                      </v-list-item-avatar>

                                      <v-list-item-content>
                                        <v-list-item-title
                                          class="body-2 text-capitalize">
                                          {{ item_action.text }}
                                        </v-list-item-title>
                                      </v-list-item-content>
                                    </v-list-item>
                                  </v-list>
                                </v-menu>
                              </v-list-item-action>
                            </v-list-item>
                          </v-list>

                          <v-card-text
                            class="pt-0">
                            <v-img
                              contain
                              height="200"
                              :src="item.url">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height"
                                  align="center"
                                  justify="center">
                                  <v-progress-circular 
                                    indeterminate 
                                    :color="set_color">
                                  </v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import { TokenService } from "@/service/Storage.Service";
  import axios from "axios";
  import moment from "moment"
  import "moment/locale/id"
  export default {
    data () {
      return {
        dialog: {
          snackbar: false,

          form: false,
          preview: false
        },

        preview_index: '',

        selected: {
          menu: 0,

          file: 0
        },

        menu: [
          {
            text: 'Detail Event',
            icon: require('@/assets/icon/event_detail.png')
          },
          {
            text: 'QR Kode',
            icon: require('@/assets/icon/qrcode.png')
          },
          {
            text: 'Pengunjung',
            icon: require('@/assets/icon/member.png')
          },
          {
            text: 'Dokumentasi',
            icon: require('@/assets/icon/archive.png')
          }
        ],

        files: [
          {
            icon: 'mdi-file-document-outline',
            text: 'PDF'
          },
          {
            icon: 'mdi-image-outline',
            text: 'Gambar'
          }
        ],

        menu_action: [
          {
            text: 'lihat',
            icon: 'mdi-eye-outline'
          },
          {
            text: 'hapus',
            icon: 'mdi-delete-circle-outline'
          }
        ],

        detail: {},

        form: {
          id: '',

          url: '',

          file_doc_json_array: [],
          image_doc_json_array: []
        },

        upload: {
          doc: false,
          image: false
        },

        process: {
          load: false,

          print: false,

          form: false,
          doc: false,
          image: false
        },
        message: {
          success: '',
          error: ''
        }
      }
    },
    components: {
      uploaddocument: () => import(/* webpackPrefetch: true */ '@/components/upload/document_pdf.vue'),
      uploadimage: () => import(/* webpackPrefetch: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'upload.doc': {
        handler: function () {
          if (this.upload.doc) {
            this.process.doc = this.upload.doc.process

            if (!this.process.doc) {
              // CALLBACK FROM UPLOAD DOC
              
              this.form.url = this.upload.doc.fileuri

              this.form.file_doc_json_array.push({
                title: this.upload.doc.filename,
                url: this.upload.doc.fileuri,
                size: this.upload.doc.filesize,
                mimetype: this.upload.doc.filemime,
                extension: this.upload.doc.filemime.split('/')[1]
              })
            }
          }
        },
        deep: true
      },

      'upload.image': {
        handler: function () {
          if (this.upload.image) {
            this.process.image = this.upload.image.process

            if (!this.process.image) {
              // CALLBACK FROM UPLOAD IMAGE
              
              this.form.url = this.upload.image.fileuri

              this.form.image_doc_json_array.push({
                title: this.upload.image.filename,
                url: this.upload.image.fileuri,
                size: this.upload.image.filesize,
                mimetype: this.upload.image.filemime,
                extension: this.upload.image.filemime.split('/')[1]
              })
            }
          }
        },
        deep: true
      }
    },
    computed: {
      company () {
        return this.$store.state.company
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        this.process.load = true

        let params = {
          id: this.$route.params.id
        }

        await get(`admin/event/detail`, { params })
        .then(response => {
          let res = response.data

          this.process.load = false

          if (res.status === 200) {
            this.detail = res.results.data
          }
        })
      },

      to_download () {
        let img = document.querySelector("#download_qr img").src

        const a = document.createElement('a')
        a.download = `QR-Code-Agenda-${this.detail.title}-${moment().format('DD-MMMM-YYYY', 'id')}-${moment().format('HH:mm:ss', 'id')}.png`
        a.href = img
        a.click()
      },

      async prints () {
        this.message.error = ''

        this.process.print = true

        let params = {
          id: this.detail.id
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}admin/event/export_participant`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          this.process.print = false

          if (res.status === 200) {
            
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport excel'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')

            link.href = url
            link.setAttribute('download', `Presensi-Peserta-Agenda-${this.detail.title}-${moment().format('DD-MMMM-YYYY', 'id')}-${moment().format('HH:mm:ss', 'id')}.xls`)

            document.body.appendChild(link)
            link.click()

          } else {
            this.message.error = res.message
          }
        })
      },

      reset () {
        if (this.$refs.form) this.$refs.form.reset()

        this.form = {
          id: this.detail.id,

          url: '',

          file_doc_json_array: this.detail.file_doc_json_array,
          image_doc_json_array: this.detail.image_doc_json_array
        }

        this.upload = {
          doc: false,
          image: false
        }

        this.process.form = false

        this.message.error = ''
      },

      async save () {
        this.message.error = ''

        const isValid = await this.$refs.form.validate()
        if (isValid) {
          this.process.form = true

          let url = this.selected.file == 0 ? 'admin/event/update_file_doc' : 'admin/event/update_image_doc'

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.fetchDetail()
            } else {
              this.message.error = res.message
            }
          })

        } else {
          // AUTO FOCUS ON TEXT-FIELD
          setTimeout(() => {
            const errors = Object.entries(this.$refs.form.errors)
              .map(([key, value]) => ({ key, value }))
              .filter(error => error['value'].length)
            this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
              behavior: 'smooth',
              block: 'center'
            })
          }, 10)
        }
      },

      async toAction (menu, index, type) {
        this.reset()

        if (menu === 'lihat') {
          this.preview_index = index

          this.dialog.preview = true
        } else {
          let url = type === 'pdf' ? 'admin/event/update_file_doc' : 'admin/event/update_image_doc'

          if (type === 'pdf') {
            this.form.file_doc_json_array.splice(index, 1)
          } else {
            this.form.image_doc_json_array.splice(index, 1)
          }

          // SAVE TO REST API
          await post(url, {
            data: this.form
          })
          .then(response => {
            let res = response.data
            
            this.process.form = false

            if (res.status === 200) {
              this.dialog.form = false

              this.dialog.snackbar = true
              this.message.success = res.message

              this.dialog.fullscreen = false

              this.fetchDetail()
            } else {
              this.message.error = res.message
            }
          })
        }
      }
    }
  }
</script>